<template>
  <div class="base-progress-bar">
    <!-- {{ currentPercent }} -->
    <div
      class="base-progress-bar__bar"
      :class="testfull"
      :style="{width: currentPercent}"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseProgressBar',
  props: {
    max: {
      type: Number,
      required: false,
      default: 100,
    },
    current: {
      type: Number,
      required: true,
    },
  },
  computed: {
    currentPercent() {
      // eslint-disable-next-line no-mixed-operators
      return `${Math.min(this.current, this.max) / this.max * 100}%`;
    },
    testfull() {
      if (this.current > this.max) {
        return 'fullbar';
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.base-progress-bar{
    height: 3px;
    background-color: rgba($primary, 0.1);
    &__bar{
        height: 3px;
        background-color: rgba($primary, 0.5);
        transition: all 0.3s;
    }
}
.fullbar {
    background-color:#6bb57c;
}
</style>
